export default __webpack_public_path__ + "media/images/react_icons/playground-e9febc9e3e3028d9d541e0f7a072cc0d.svg";